import { CSSProperties } from "react";
import logo from "./logo.svg";

export default function BoomIcon(props: {
  style?: CSSProperties;
  className?: string;
}) {
  return (
    <img
      src={logo}
      alt="Boom"
      style={props.style}
      className={props.className}
    />
  );
}
